import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const DownloadDocumentButton = ({
  onClick,
  documentId,
  documentIdDownloading,
}) => {
  const isDownloading = documentId === documentIdDownloading;
  return (
    <Button
      title={isDownloading ? 'Downloading' : 'Download Document'}
      className="btn btn-outline-primary"
      onClick={onClick}
    >
      {isDownloading && <i className="fa fa-spin fa-spinner" />}
      {!isDownloading && <i className="fa fa-download" />}
    </Button>
  );
};

const Document = ({ document, onDownloadDocument, documentIdDownloading }) => {
  return (
    <li
      className="list-group-item document-item"
      key={document.sharedDocumentId}
    >
      <div className="flextable">
        <div className="flextable-item flextable-primary">
          {document.sharedDocumentName}
        </div>
        <div className="flextable-item">
          <ButtonGroup>
            <DownloadDocumentButton
              onClick={onDownloadDocument}
              documentIdDownloading={documentIdDownloading}
              documentId={document.sharedDocumentId}
            />
          </ButtonGroup>
        </div>
      </div>
    </li>
  );
};

class QuoteSharedDocumentsListViewComponent extends React.PureComponent {
  static propTypes = {
    documents: PropTypes.array.isRequired,
    onDownload: PropTypes.func.isRequired,
    documentIdDownloading: PropTypes.string,
  };

  downloadDocument(document) {
    this.props.onDownload(document);
  }

  render() {
    const { documents, documentIdDownloading } = this.props;

    return (
      <React.Fragment>
            <div className="card mb-3 box-shadow quote-products flex-fill">
              <div className="card-body">
                <h6 className="card-title text-center">Documents</h6>
                <ul className="list-group list-group-flush">
                  {documents.map((document) => {
                    return (
                      <Document
                        key={document.sharedDocumentId}
                        document={document}
                        onDownloadDocument={() =>
                          this.downloadDocument(document)
                        }
                        documentIdDownloading={documentIdDownloading}
                      />
                    );
                  })}
                </ul>
                {documents.length === 0 && (
                  <div className="row">
                    <div className="col text-center">
                      This quote has no documents
                    </div>
                  </div>
                )}
              </div>
            </div>
      </React.Fragment>
    );
  }
}

export default withRouter(QuoteSharedDocumentsListViewComponent);
